import { PLAYBOOK_TRACKER } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import PlaybookTracker from './index';

const module: ModulesList = {
  [PLAYBOOK_TRACKER]: {
    path: '/playbook-tracker',
    component: PlaybookTracker,
  },
};

export default module;
